export const IDENTITY_BUSINESS_ERROR = 'identity.businessError'
export const ACTIVATION_BUSINESS_ERROR = 'activation.businessError'
export const GATEWAY_CLIENT_BAD_REQUEST = 'gateway.client.badRequest'
export const TOO_MANY_REQUESTS = 'Too Many Requests'
export const BUSINESS_VALIDATION_FAILURE = 'Business Validation Failure'
export const ENCOUNTERED_BUSINESS_ERROR = 'Encountered Business Error'
export const INVALID_CLIENT_ID = 'Invalid clientId'
export const IOVATION_AUTH_ERROR_CODE = 'idp.authenticate.login.error.csr3'
export const IOVATION_AUTH_ERROR_MESSAGE = 'csr3 error'
